export class ContactMessageHistoryDtoRequest {

  public contactId: number;
  public email: string;
  public mobile: string;    
  public sortColumn: string;
  public sortDirection: string;
  
  constructor(init: { contactId: number;
                      email: string,
                      mobile: string,
                      sortColumn: string,
                      sortDirection: string }) {

    this.contactId = init.contactId;                   
    this.email = init.email;
    this.mobile = init.mobile;
    this.sortColumn = init.sortColumn;
    this.sortDirection = init.sortDirection;
  }
}
